import {withStyles} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {getDirectionStyles} from '../../utils/ThemeUtils';

export const CloseButton = withStyles(theme => ({
    root: {
        position: 'absolute',
        right: theme.spacing(3),
        top: theme.spacing(3),
        color: theme.palette.common.white
    },
    startIcon: {
        marginRight: 0
    }
}))(Button);

export const DialogButton = withStyles(theme => ({
    root: {
        width: 150,
        padding: theme.spacing(3, 0)
    }
}))(Button);

export const Dialog = withStyles(theme => ({
    paper: {
        direction: theme.direction,
        height: '100%',
        maxHeight: 520,
        padding: theme.spacing(12, 3, 3, 3),
        minWidth: 345,
        width: 345,

        [theme.breakpoints.up('fsm')]: {
            width: 640,
            maxHeight: 590,
            padding: theme.spacing(12, 9, 7, 9)
        },
        [theme.breakpoints.up('fmd')]: {
            width: 790,
            maxHeight: 700,

            padding: theme.spacing(12, 12, 7, 12)
        }
    }
}))(MuiDialog);

export const DialogContent = withStyles({
    root: {
        padding: 0,
        overflow: 'hidden',

        '& > div > div:nth-of-type(2)': {
            width: '100%',
            overflow: 'hidden',

            '& img': {
                width: '100%',
                borderRadius: '4px'
            }
        }
    }
})(MuiDialogContent);

export const DialogActions = withStyles(theme => ({
    root: {
        direction: theme.direction,
        margin: theme.spacing(4, 0, 0, 0),
        padding: 0,

        [theme.breakpoints.up('fsm')]: {
            margin: theme.spacing(8, 0, 0, 0)
        },
        [theme.breakpoints.up('fmd')]: {
            margin: theme.spacing(12, 0, 0, 0)
        }
    }
}))(MuiDialogActions);

export const StepWrapper = withStyles(theme => ({
    root: {
        margin: '0 auto 20px auto',

        [theme.breakpoints.up('fsm')]: {
            margin: getDirectionStyles(theme.direction)('0 auto 0 0', '0 0 0 auto')
        }
    }
}))(Box);
